export default __webpack_public_path__ + "static/Measure Logo-6556851f6e70eb07a5381b7d4d0762b0.png";